import { removeCookie } from '../service/cookieService';
import { getAuthToken, getAffiliateDetails, getAuthCookieKey } from './appUtils';

const getLoginStatus = () => {
  const mmtAuth = getAuthToken();
  if (typeof mmtAuth !== 'undefined' && mmtAuth !== null && mmtAuth !== '') {
    return true;
  }
  return false;
};

export const logoutUser = () => {
  const affiliateDetails = getAffiliateDetails();
  const authCookieKey = getAuthCookieKey();
  removeCookie(authCookieKey, { path: '/', domain: affiliateDetails.authCookieDomain });
  window.localStorage.removeItem('agentInfo');
  window.location.reload();
};

export { getLoginStatus };
